module.exports = __webpack_public_path__ + "img/stock7.c5b19046.png";